// @flow

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ResizeObserver from 'react-resize-observer';
import {
  updateDimensions,
} from './modules/map';

type Props = {
  updateDimensions: ({ width: number, height: number }) => void,
};

class SizeUpdater extends PureComponent<Props> {
  static contextTypes = {
    map: PropTypes.object.isRequired,
  };

  onResize = (rect) => {
    const { map } = this.context;

    if (process.env.NODE_ENV !== 'production') {
      window.map = map;
    }

    map.resize();
    this.props.updateDimensions(rect);
  }

  render = () => <ResizeObserver onResize={this.onResize} />;
}

const mapDispatchToProps = {
  updateDimensions,
};

export default connect(
  null,
  mapDispatchToProps,
)(SizeUpdater);



// WEBPACK FOOTER //
// ./src/size-updater.js